import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {DateUtil} from '../../../../../../common/util/DateUtil';
import {EntRequestBuilder} from '../../../../../services/ent-request-builder';
import {PolicyProductVarianceLinkDTO} from '../../../../../models/PolicyProductVarianceLinkDTO';

enum TableColumns {
  Product = 'product',
  Person = 'person',
  ProductVariance = 'productVariance',
  StartDate = 'startDate',
  EndDate = 'endDate'
}

@Component({
  selector: 'app-policy-product-variances',
  templateUrl: './policy-product-variances.component.html',
  styleUrls: [
    '../../../../../../../../styles/global/_add-view-edit-styles.scss',
    '../../../../../../../../styles/global/_management-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolicyProductVariancesComponent implements OnChanges {
  readonly tableColumns = TableColumns;
  readonly dateFormat = DateUtil.dateFormat;
  readonly paginatorControls = EntRequestBuilder.getTableControls();

  displayedColumns: string[] = Object.values(TableColumns);
  dataSource: MatTableDataSource<PolicyProductVarianceLinkDTO> = new MatTableDataSource();

  @Input() data: PolicyProductVarianceLinkDTO[];

  @ViewChild('MatSortPolicyProductVariances') set matSort(ms: MatSort) {
    if (!ms) {
      return;
    }
    this.dataSource.sortingDataAccessor = (item: PolicyProductVarianceLinkDTO, property: string) => {
      switch (property) {
        case TableColumns.Product:
          return item[TableColumns.Product].name;
        case TableColumns.Person:
          return item[TableColumns.Person].name;
        case TableColumns.ProductVariance:
          return item[TableColumns.ProductVariance].name;
        case TableColumns.StartDate:
          return item[TableColumns.StartDate];
        case TableColumns.EndDate:
          return item[TableColumns.EndDate];
        default:
          return item[property];
      }
    };
    this.dataSource.sort = ms;
  }

  @ViewChild('MatPaginatorPolicyProductVariances') set matPaginator(mp: MatPaginator) {
    if (!mp) {
      return;
    }
    this.dataSource.paginator = mp;
  }

  get isDataExist() {
    return this.dataSource && this.dataSource.data?.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;
      this.setFormsForEdit(this.data);
    }
  }

  private setFormsForEdit(data: PolicyProductVarianceLinkDTO[]) {
    if (data && data?.length) {
      this.dataSource.data = data;
    }
    else {
      this.dataSource.data = [];
    }
  }
}
